import { MParticleAdapter } from './mparticle-adapter';

export const getSessionId = async (): Promise<{ sessionId: string | null }> => {
  return await MParticleAdapter.getSession();
};
